<template>
  <div class="base-course-module">
    <el-tabs v-if="type === 3" v-model="relationId" class="custom-tabs" @tab-click="search">
      <el-tab-pane label="全部" name="" />
      <el-tab-pane v-for="item of course2List" :key="item.course.id" :label="item.course.name" :name="item.course.id" />
    </el-tabs>
    <el-form :model="filter" inline size="small">
      <el-form-item :label="label + '名称'">
        <el-input v-model="filter.name" :placeholder="`请输入${label}名称`" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="" size="small" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-card style="margin-top: 10px">
      <el-row v-if="(type !== 3 || (type === 3 && relationId !== '0')) && checkAdmin()" style="margin-bottom: 10px;">
        <el-button :disabled="type === 1 && courseList && courseList.length !== 0" type="primary" size="small" @click="add">添加</el-button>
        <el-button v-if="type !== 1" type="danger" size="small" @click="dels">删除</el-button>
      </el-row>
      <el-table :data="courseList" border @selection-change="handleSelectionCourse">
        <template v-if="type !== 1">
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column v-if="type !== 3" align="center" label="排序号" prop="sortNum">
            <template v-slot="{ row }">
              <el-input v-model="row.sortNum" :readonly="!checkAdmin()" @blur="blurSort(row)"></el-input>
            </template>
          </el-table-column>
        </template>
        <el-table-column align="center" :label="label + '名称'" prop="name">
          <template v-slot="{ row: { course } }">
            <span>{{ course.name  }}</span>
          </template>
        </el-table-column>
        <template v-if="type === 3">
          <el-table-column align="center" label="课程预约开始时间">
            <template v-slot="{ row: { course } }">
              <span>{{ course.beginDate  }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="课程预约结束时间">
            <template v-slot="{ row: { course } }">
              <span>{{ course.endDate  }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column align="center" label="课时数" prop="numLesperiod" />
        <el-table-column align="center" label="更新时间" prop="lastUpdateDate" />
        <el-table-column align="center" label="最后操作人" prop="lastUpdateName" />
        <el-table-column align="center" label="操作" min-width="80">
          <template v-slot="{ row }">
            <el-button type="text" @click="viewHour(row.course)">查看课时</el-button>
            <el-button v-if="checkAdmin()" type="text" @click="del(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!-- 添加绑定 -->
    <el-dialog :title="`添加${label}`" :visible.sync="bingDialogVisible" class="bing-dialog" width="860px" :before-close="handleCloseBing" append-to-body>
      <el-form :model="bingFilter" size="small" inline>
        <el-form-item :label="label + '名称'" prop="name">
          <el-input v-model="bingFilter.name" :placeholder="`请输入${label}名称`" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchCourse">搜索</el-button>
          <el-button type="" @click="resetCourse">重置</el-button>
        </el-form-item>
      </el-form>
      <el-card>
        <el-table
          :data="allCourse"
          :max-height="540"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column v-if="type !== 1" :selectable="selectable" type="selection" align="center" width="55" />
          <el-table-column align="center" width="55" v-if="type === 1">
            <template v-slot="{ row }">
              <el-radio v-model="pickedCourseId" :label="row.id"><span /></el-radio>
            </template>
          </el-table-column>
          <el-table-column :label="label + '名称'" align="center" prop="name" />
          <template v-if="type === 3">
            <el-table-column align="center" label="课程预约开始时间" min-width="120">
              <template v-slot="{ row }">
                <span>{{ row.beginDate  }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="课程预约结束时间" min-width="120">
              <template v-slot="{ row }">
                <span>{{ row.endDate  }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="课时数" align="center" prop="lesperiodTotal" />
          <el-table-column align="center" label="操作" min-width="110">
            <template v-slot="{ row }">
              <el-button type="text" @click="viewHour(row)">查看课时</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="bingFilter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="bingFilter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="bingFilterTotal"
          @size-change="handleBingFilterSizeChange"
          @current-change="handleBingFilterCurrentChange"
        />
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseBing">取 消</el-button>
        <el-button type="primary" size="small" @click="bingCourse">确 定</el-button>
      </span>
    </el-dialog>
    <CourseHour ref="hourEl" @close="getList" />
  </div>
</template>

<script>
import CourseHour from '@/views/class/courseManage/components/CourseHour.vue';

import {
  getClassCourseList,
  addClassCourse,
  delClassCourse,
  delClassCourses
} from '@/api/product/classManage';
import { getPageList, updateCourseSort } from '@/api/product/courseManage'

export default {
  name: 'BaseCourse',

  components: { CourseHour },
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      relationId: null,
      course2List: [],
      filter: {
        page: 1,
        limit: 10,
        name: ''
      },
      total: 0,
      courseList: [],
      ownCouseIds: [], // 选择的课程ID
      bingDialogVisible: false,
      bingFilter: {
        page: 1,
        limit: 10,
        name: null,
        type: this.type
      },
      bingFilterTotal: 0,
      allCourse: [],
      couseIds: [],
      pickedCourseId: null,
    }
  },
  computed: {
    label() {
      switch (this.type) {
        case 1:
          return '基础必学课程'
        case 2:
          return '职业方向课程'
        case 3:
          return '实操课程'
        default:
          return ''
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.type === 3) {
        // 获取职业方向课程列表
        const params = {
          skuId: this.id,
          type: 2,
          page: 1,
          limit: -1
        }
        getClassCourseList(params).then(({ code, data }) => {
          if (code === 0) {
            this.course2List = data.records
          }
        })
      }
      this.getList()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.filter = this.$options.data().filter
      this.getList()
    },
    // 列表
    async getList() {
      const params = {
        skuId: this.id,
        type: this.type,
        ...this.filter
      }
      if (this.type === 3 && this.relationId !== '0') {
        params.relationId = this.relationId
      }
      const res = await getClassCourseList(params)
      if (res.code !== 0) return this.$message.error(res.message)
      this.courseList = res.data.records
      this.total = +res.data.total
    },
    async blurSort(row) {
      if (!checkAdmin()) return
      if (!/^\d{1,}$/.test(row.sortNum)) {
        this.getList()
        return this.$message.warning('请输入0或正整数')
      }
      const res = await updateCourseSort({ id: row.id, sortNum: row.sortNum })
      this.getList()
      this.$message.success('操作成功')
    },
    // 批量选择课程
    handleSelectionCourse(val) {
      this.ownCouseIds = val.map(item => item.id)
    },
    add() {
      this.handleGetCourseList()
      this.bingDialogVisible = true
    },
    del(id) {
      this.$confirm(`确认删除当前课程?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delClassCourse({ id })
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success('删除成功!')
        this.getList()
      })
    },
    dels() {
      if(this.ownCouseIds.length === 0) {
        this.$message.warning('请选择课程!')
        return
      }
      this.$confirm(`确认删除选择的课程?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ids = this.ownCouseIds.join(',')
        const res = await delClassCourses({ ids })
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success('删除成功!')
        this.getList()
      })
    },
    selectable(row, index) {
      return row.isBind === 2
    },
    viewHour(row) {
      this.$refs.hourEl.show(row, true)
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    searchCourse() {
      this.bingFilter.page = 1
      this.handleGetCourseList()
    },
    resetCourse() {
      this.bingFilter = this.$options.data().bingFilter
      this.handleGetCourseList()
    },
    // 获取课程列表
    handleGetCourseList() {
      this.bingFilter.type = this.type
      getPageList({...this.bingFilter, skuId: this.id}).then(({ code, data }) => {
        if (code === 0) {
          this.allCourse = data.records
          this.bingFilterTotal = parseInt(data.total, 10)
        }
      })
    },
    // 点击选择
    handleSelectionChange(val) {
      this.couseIds = val.map(item => item && item.id)
    },
    // 绑定课程
    bingCourse() {
      if((this.type !== 1 && this.couseIds.length === 0) || (this.type === 1 && !this.pickedCourseId)) {
        this.$message.warning('请选择课程!')
        return
      }
      const params = {
        type: this.type,
        skuId: this.id
      }
      if (this.type !== 1) {
        params.couseIds = this.couseIds.join(',')
      } else {
        params.couseIds = this.pickedCourseId
      }
      if (this.relationId !== '0') {
        params.relationId = this.relationId
      }
      addClassCourse(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('绑定课程成功!')
          if (this.type === 1) {
            this.handleCloseBing()
          } else {
            // this.bingFilter = this.$options.data().bingFilter
            this.allCourse = []
            this.couseIds = []
            this.handleGetCourseList()
          }
          this.search()
        }
      })
    },
    handleCloseBing() {
      this.bingFilter = this.$options.data().bingFilter
      this.allCourse = []
      this.couseIds = []
      this.bingDialogVisible = false
    },
    handleBingFilterSizeChange(v) {
      this.bingFilter.page = 1
      this.bingFilter.limit = v
      this.handleGetCourseList()
    },
    handleBingFilterCurrentChange(v) {
      this.bingFilter.page = v
      this.handleGetCourseList()
    },
  },
}
</script>

<style lang="scss" scoped>
.bing-dialog {
  ::v-deep .el-radio__label {
    padding: 0;
  }
}
.el-table ::v-deep input {
  text-align: center;
}
</style>
